function once<T>(fn: T): T {
  let hasRun = false
  let result: unknown

  if (typeof fn !== 'function') {
    throw new Error('fn is not a function.')
  }

  // @ts-ignore
  return function run() {
    if (hasRun) return result
    hasRun = true

    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    result = fn.apply(this, arguments)
    return result
  }
}

export default once
